import { render, staticRenderFns } from "./payfor-refund-edit.vue?vue&type=template&id=5473e194"
import script from "./payfor-refund-edit.vue?vue&type=script&lang=js"
export * from "./payfor-refund-edit.vue?vue&type=script&lang=js"
import style0 from "./payfor-refund-edit.vue?vue&type=style&index=0&id=5473e194&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports